import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor";

interface Props {
  command: (item: any) => void;
  href: string;
}

interface UnfurlEntityLink {
  sgid: string;
  type: string;
}

export const EntityPaste = ({ href, command }: Props): any => {
  const tiptapEditorContext = useTipTapEditorContext();
  const tiptapBlockEditorContext = useBlockEditorContext();
  const { addToLocalSgidToObjectMap } =
    tiptapEditorContext || tiptapBlockEditorContext;

  useQuery(
    internalApi.richTextFields.unfurlURLs({
      params: { urls: [href] },
    }),
    {
      initialData: [],
      onSuccess: data => {
        const entityLink: UnfurlEntityLink = data?.[0] ?? {
          type: "",
          sgid: "",
        };

        if (entityLink.type) {
          addToLocalSgidToObjectMap({
            sgid: entityLink.sgid,
            object: entityLink,
          });
          command(entityLink.sgid);
        }
      },
    },
  );

  return null;
};

EntityPaste.displayName = "EntityPaste";
